import React, { useCallback } from 'react';
import { Alignment, IconName, Intent, Navbar } from '@blueprintjs/core';
import { Container } from './styles';
import PinPad from '../PinPad';
import Toaster from '../Toaster';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { AuthState } from '../../views/auth/types';
import { doPinLogin, setUsername } from '../../views/auth/reducer';
import LoginHeaderButton from '../LoginHeaderButton';
import { ReactComponent as WavelightLogo } from '../../assets/wavelight-minimal-logo-black.svg';

interface MainContainerProps {
  children: React.ReactNode;
}

const MainContainer = ({ children }: MainContainerProps) => {
  const dispatch = useAppDispatch();
  const state: AuthState = useAppSelector((state) => state.auth);

  const showToasterMessage = useCallback(
    async (message: React.ReactChild, intent: Intent, icon: IconName) => {
      (await Toaster).show({
        message,
        intent,
        icon,
      });
    },
    [],
  );

  const doSetUserName = useCallback(
    (value: string) => {
      dispatch(setUsername(value));
    },
    [dispatch],
  );

  const doLoginWithPin = useCallback(
    (pin: string) => {
      dispatch(
        doPinLogin({
          username: state.login.username,
          pin,
        }),
      ).catch((error: Error) => {
        showToasterMessage(<>{error.message}</>, Intent.DANGER, 'warning-sign');
      });
    },
    [dispatch, showToasterMessage, state.login.username],
  );

  return (
    <Container>
      <Navbar>
        <Navbar.Group align={Alignment.LEFT}>
          <WavelightLogo />
          <Navbar.Heading>Wavelight Capture</Navbar.Heading>
        </Navbar.Group>
        {state.session.logged && (
          <Navbar.Group align={Alignment.RIGHT}>
            <LoginHeaderButton />
          </Navbar.Group>
        )}
      </Navbar>
      {children}
      {!state.session.logged && (
        <PinPad
          username={state.login.username}
          onSetUsername={doSetUserName}
          onPinAction={doLoginWithPin}
          isLoading={state.isLoading}
        />
      )}
    </Container>
  );
};

export default MainContainer;
